var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _rect, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _g, _g2, _g3, _g4, _g5, _g6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgParadigmLogoSignInPage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Student_Splash_Page",
    "data-name": "Student Splash Page",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 360 70",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        clip-path: url(#clippath-4);\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-3 {\n        fill: #fff;\n      }\n\n      .cls-4 {\n        fill: none;\n      }\n\n      .cls-5 {\n        fill: url(#linear-gradient-4);\n      }\n\n      .cls-6 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-7 {\n        clip-path: url(#clippath-1);\n      }\n\n      .cls-8 {\n        fill: url(#linear-gradient-5);\n      }\n\n      .cls-9 {\n        clip-path: url(#clippath-5);\n      }\n\n      .cls-10 {\n        clip-path: url(#clippath-3);\n      }\n\n      .cls-11 {\n        fill: url(#linear-gradient-6);\n      }\n\n      .cls-12 {\n        clip-path: url(#clippath-2);\n      }\n\n      .cls-13 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-14 {\n        clip-path: url(#clippath);\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 111.41,
    y: 2.64,
    width: 11.97,
    height: 11.97,
    transform: "translate(83.92 121.47) rotate(-77.68)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 923.75,
    y1: 1407.84,
    x2: 924.87,
    y2: 1407.84,
    gradientTransform: "translate(9997.82 -15040.52) rotate(-180) scale(10.69 -10.69)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#88c665"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#83c363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#76bc5f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#60b058"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#429f4d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1b8a41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007b38"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 98.02,
    y: 27.83,
    width: 11.97,
    height: 11.97
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 1062.74,
    y1: 1439.11,
    x2: 1063.86,
    y2: 1439.11,
    gradientTransform: "translate(11479.39 -15342.69) rotate(-179.97) scale(10.69 -10.69)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f6921e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#f58b1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#f37722"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#f05a28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#ee4036"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ee4036"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 83.74,
    y: 27.83,
    width: 11.97,
    height: 11.97
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 903.55,
    y1: 1420.56,
    x2: 904.67,
    y2: 1420.56,
    gradientTransform: "translate(-15090.88 -9640.62) rotate(90.03) scale(10.69 -10.69)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00a0e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#019bdf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#078ed6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#1078c6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#1c5aaf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#2c3392"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2e3191"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-3"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 110,
    y: 15.87,
    width: 11.97,
    height: 11.97
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 903.44,
    y1: 1420.83,
    x2: 904.56,
    y2: 1420.83,
    gradientTransform: "translate(-15068.2 -9651.81) rotate(90.03) scale(10.69 -10.69)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 95.78,
    y: 15.87,
    width: 11.97,
    height: 11.97
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 903.43,
    y1: 1420.68,
    x2: 904.55,
    y2: 1420.68,
    gradientTransform: "translate(-15078.76 -9650.43) rotate(90.03) scale(10.69 -10.69)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#88c665"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#83c363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#76ba5e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#60ac55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#42984a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1b7f3b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006e31"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-5"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 109.99,
    y: 27.83,
    width: 11.97,
    height: 11.97
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 1062.61,
    y1: 1439.11,
    x2: 1063.73,
    y2: 1439.11,
    gradientTransform: "translate(11491.05 -15344.2) rotate(-179.97) scale(10.69 -10.69)",
    xlinkHref: "#linear-gradient-2"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M91.02,66.24c-.24-.78-.52-1.52-.99-2.72h-4.09l-.18.45c-.3.74-.58,1.49-.81,2.28l-.12.07c-.1-.01-.28-.02-.43-.02s-.3.01-.44.02l-.07-.11c1.06-2.39,2.33-5.66,3.43-8.26l.09-.07c.41-.01.98-.01,1.26-.02l.1.06c.66,1.58,2.25,5.58,3.43,8.3l-.07.08c-.43.01-1,.02-1,.02l-.09-.08ZM87.94,58.31l-1.77,4.56c.61.01,1.2.01,1.79.01s1.2,0,1.79-.01l-1.8-4.56Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M98,66.26c.02-.59.03-1.16.03-1.73,0-.69-.09-5.74-.15-6.58l.1-.06c2.4-.01,2.79-.02,3.2-.02.96,0,1.98.07,2.82.38,1.17.42,2.42,1.41,2.42,3.63,0,.29,0,.97-.31,1.72-.53,1.27-1.65,2.15-3.27,2.52-.92.2-1.77.2-2.72.2h-1.32c-.24,0-.47,0-.71.01l-.09-.07ZM99.86,65.7c.81,0,1.91,0,2.7-.19,2.82-.66,2.85-3.18,2.85-3.74,0-.72-.03-3.28-4.19-3.28-.3,0-1.8.01-2.25.04v4.02c0,.9.06,3.15.06,3.15h.83Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M109.23,66.32c-.32,0-.63,0-.93.01l-.09-.07c.01-.59.03-1.17.03-1.76,0-.7-.03-5.48-.13-6.56l.09-.06c.31,0,.63,0,.93-.02l.09.08s-.02.78-.02,1.67v2.75c0,.75.1,3.06.12,3.88l-.09.07Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M118.59,57.95c-.21.53-.48,1.1-.71,1.64l-1.67,4.07c-.44,1.06-.66,1.72-1.02,2.58l-.1.08c-.39,0-.81,0-1.22.02l-.1-.06c-.35-.87-.68-1.74-1.02-2.6l-1.28-3.22c-.33-.84-.65-1.65-.99-2.47l.06-.08c.33-.01.66-.04.99-.06l.08.06c.42,1.05.72,2.07,1.11,3.11l1.83,4.76,2.21-5.7c.29-.73.54-1.42.77-2.14l.1-.07s.3.01.47.01c.15,0,.42-.01.42-.01l.07.08Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M120.92,66.32c-.32,0-.63,0-.93.01l-.09-.07c.01-.59.03-1.17.03-1.76,0-.7-.03-5.48-.13-6.56l.09-.06c.31,0,.63,0,.93-.02l.09.08s-.02.78-.02,1.67v2.75c0,.75.1,3.06.12,3.88l-.09.07Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M128.39,58.93c-.68-.32-1.26-.59-2.4-.59-1.67,0-2.37.74-2.37,1.52,0,.87.81,1.18,1.82,1.52l1.25.42c1.2.41,2.31,1.03,2.31,2.3,0,1.17-1.08,2.4-3.5,2.4-.42,0-1.62-.04-2.72-.61l-.06-.13c.03-.24.04-.54.06-.72l.15-.02c.15.13.98.84,2.57.84,1.49,0,2.52-.7,2.52-1.73s-1.16-1.44-1.95-1.71l-1.22-.41c-1.23-.42-2.19-1.1-2.19-2.11,0-.38.21-2.19,3.36-2.19,1.28,0,2.04.27,2.52.48l.09.1-.09.59-.15.06Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M131.64,66.32c-.31,0-.63,0-.93.01l-.09-.07c.02-.59.03-1.17.03-1.76,0-.7-.03-5.48-.14-6.56l.09-.06c.32,0,.63,0,.93-.02l.09.08s-.01.78-.01,1.67v2.75c0,.75.1,3.06.12,3.88l-.09.07Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M138.32,57.71c4.05,0,4.7,2.83,4.7,4.39,0,2.32-1.38,4.39-4.81,4.39s-4.82-1.96-4.82-4.38c0-2.01,1.13-4.41,4.93-4.41ZM138.28,58.34c-2.69,0-3.89,1.64-3.89,3.77,0,1.53.74,3.75,3.83,3.75s3.78-2.2,3.78-3.76c0-1.96-.95-3.76-3.73-3.76Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M152.71,66.31c-.5.01-1.34.02-1.34.02l-.12-.06c-.48-.62-.96-1.27-1.43-1.92l-4.16-5.86c.03.97.03,6.86.15,7.76l-.09.07c-.27,0-.53,0-.78.02l-.11-.08c.02-.74.02-1.48.02-2.21s-.04-5.6-.12-6.1l.09-.07c.39,0,.89-.01,1.32-.02l.14.07c2,2.7,2.72,3.7,5.62,7.79,0-1.05-.08-7.05-.17-7.77l.07-.06c.26-.01.57-.02.8-.02l.09.06c-.02.57-.03,1.15-.03,1.72,0,.88,0,1.77.02,2.65.02,1.33.06,2.62.12,3.95l-.09.07Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M162.5,57.71c3.99,0,4.63,2.83,4.63,4.39,0,2.32-1.36,4.39-4.73,4.39s-4.74-1.96-4.74-4.38c0-2.01,1.11-4.41,4.85-4.41ZM162.47,58.34c-2.64,0-3.83,1.64-3.83,3.77,0,1.53.72,3.75,3.77,3.75s3.72-2.2,3.72-3.76c0-1.96-.93-3.76-3.67-3.76Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M170.54,61.71c.68,0,2.1-.04,3.18-.05l.09.07c-.03.19-.04.37-.06.55l-.09.07c-.96,0-2.22-.02-2.66-.02-.19,0-1.09.01-1.09.01,0,1.3.03,2.59.1,3.91l-.09.07c-.31,0-.61,0-.9.01l-.09-.07c.02-.62.03-1.23.03-1.85,0-.76-.07-5.7-.13-6.46l.09-.07c.19.01.84.01,1.12.01h2.48c.19,0,1.55-.02,2.02-.02l.07.06c-.03.19-.04.37-.06.58l-.1.06c-1.08-.01-1.92-.05-4.6-.06,0,.69.01,1.22.01,1.7v1.5h.66Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M187.18,66.31h-.51c-.21,0-.42.02-.63.04l-.17-.06c-.72-.68-1.44-1.36-2.18-2.03-.89-.81-1.8-1.6-2.72-2.38.03,1.1.08,3.45.14,4.37l-.11.06c-.29,0-.58.01-.89.02l-.09-.07c0-.14.03-.93.03-1.43,0-.62-.02-3.15-.02-3.15-.01-1.19-.06-2.52-.12-3.73l.09-.07c.23,0,.62,0,.9-.01l.08.07v3.88l2.03-1.79c.8-.7,1.59-1.37,2.33-2.1l.15-.05c.18.01.38.01.56.01s.35,0,.53-.01l.04.08c-.93.75-1.83,1.51-2.72,2.28l-1.77,1.54.81.72c.75.66,3.62,3.15,4.28,3.71l-.04.1Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M190.94,61.6c1.07,0,2.1,0,3.17-.04l.09.08c-.03.18-.04.35-.04.53l-.14.07c-.6-.02-.83-.02-1.68-.02-.33,0-2,.01-2.85.01,0,1.15.03,2.46.06,3.44,3.02,0,3.09-.02,4.91-.05l.06.07-.04.56-.07.07c-.59,0-.89-.01-1.76-.01h-2.66c-.41,0-.98.02-1.38.05l-.1-.1c.03-.61.03-1.22.03-1.83,0-.84,0-1.68-.01-2.52,0-.47-.1-3.52-.12-3.98l.09-.08c.47.01,1.25.02,1.95.02h1.79c.42,0,1.4-.02,2.12-.02l.09.06c-.03.17-.03.38-.04.57l-.12.07c-1.29-.04-2.63-.04-4.82-.05,0,.19.02.78.02,1.4v1.68h1.49Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M203.94,66.31c-.5.01-1.34.02-1.34.02l-.12-.06c-.48-.62-.96-1.27-1.43-1.92l-4.16-5.86c.03.97.03,6.86.15,7.76l-.09.07c-.27,0-.53,0-.78.02l-.11-.08c.02-.74.02-1.48.02-2.21s-.04-5.6-.12-6.1l.09-.07c.39,0,.89-.01,1.32-.02l.14.07c2,2.7,2.72,3.7,5.62,7.79,0-1.05-.08-7.05-.17-7.77l.07-.06c.26-.01.57-.02.8-.02l.09.06c-.02.57-.03,1.15-.03,1.72,0,.88,0,1.77.02,2.65.02,1.33.06,2.62.12,3.95l-.09.07Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M206.33,66.26c.01-.59.03-1.16.03-1.73,0-.69-.09-5.74-.15-6.58l.1-.06c2.4-.01,2.79-.02,3.2-.02.96,0,1.98.07,2.82.38,1.17.42,2.42,1.41,2.42,3.63,0,.29,0,.97-.32,1.72-.52,1.27-1.65,2.15-3.27,2.52-.92.2-1.77.2-2.72.2h-1.32c-.24,0-.47,0-.71.01l-.09-.07ZM208.19,65.7c.81,0,1.91,0,2.7-.19,2.82-.66,2.85-3.18,2.85-3.74,0-.72-.03-3.28-4.19-3.28-.3,0-1.8.01-2.25.04v4.02c0,.9.06,3.15.06,3.15h.83Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M222.32,66.24c-.24-.78-.52-1.52-1.01-2.72h-4.16l-.18.45c-.3.74-.59,1.49-.83,2.28l-.12.07c-.1-.01-.29-.02-.44-.02s-.3.01-.45.02l-.07-.11c1.08-2.39,2.37-5.66,3.48-8.26l.09-.07c.42-.01.99-.01,1.28-.02l.1.06c.68,1.58,2.28,5.58,3.48,8.3l-.07.08c-.44.01-1.02.02-1.02.02l-.09-.08ZM219.2,58.31l-1.8,4.56c.62.01,1.22.01,1.82.01s1.22,0,1.82-.01l-1.83-4.56Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M230.28,65.7c-.01.19-.04.38-.04.57l-.09.07c-.36-.01-1.8-.02-2.16-.02h-1.86c-.42,0-.84,0-1.26.02l-.09-.08c.02-.75.03-1.51.03-2.27s-.06-5.53-.13-6.03l.1-.07c.31,0,.63-.01.95-.02l.09.07c-.03.96-.05,1.9-.05,2.84,0,.6.05,4.51.06,4.91h.87c.95,0,2.34-.02,3.51-.07l.07.08Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M237.13,65.7c-.01.19-.04.38-.04.57l-.09.07c-.36-.01-1.8-.02-2.16-.02h-1.86c-.42,0-.84,0-1.26.02l-.09-.08c.02-.75.03-1.51.03-2.27s-.06-5.53-.13-6.03l.1-.07c.31,0,.63-.01.95-.02l.09.07c-.03.96-.05,1.9-.05,2.84,0,.6.05,4.51.06,4.91h.87c.95,0,2.34-.02,3.51-.07l.07.08Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M248.82,66.27c.02-.43.02-.97.02-1.43v-2.77c-.71-.01-1.41-.02-2.1-.02-1.25,0-2.52.01-3.77.04,0,.37.03,3.88.09,4.18l-.09.06c-.32,0-.69.02-.9.02l-.09-.07v-4.86c0-1.16-.03-2.3-.1-3.46l.09-.06c.23-.01.62-.01.92-.02l.09.07c-.02.53-.02,1.64-.02,2.01v1.47c.96.01,2.45.01,3.03.01.42,0,1.61-.01,2.84-.05-.02-.7-.02-1.44-.04-2.16-.02-.42-.06-.97-.06-1.27l.09-.06c.3,0,.62-.01.92-.02l.09.08c-.02.66-.02,1.96-.02,1.96,0,1.83.07,5.45.13,6.34l-.09.07c-.31,0-.62.01-.92.02l-.1-.07Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M259.73,57.94v.66c0,.91-.02,2.05-.02,4.75,0,.94-.23,1.52-.56,1.91-.45.54-1.46,1.24-3.38,1.24-1.74,0-2.64-.63-3.08-1.12-.59-.66-.59-1.54-.59-2.32,0,0,.03-2.62.03-3.08,0-.72,0-1.3-.03-2.02l.09-.08s.72-.01.96-.02l.08.07c-.03.7-.09,3.24-.09,3.25v2.09c0,.85.09,2.57,2.76,2.57,1.41,0,2.18-.48,2.55-1.07.33-.53.35-1.23.35-2.51,0-1.43,0-2.87-.08-4.29l.09-.08s.12,0,.81-.01l.09.07Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M269.9,66.31c-.5.01-1.34.02-1.34.02l-.12-.06c-.48-.62-.96-1.27-1.43-1.92l-4.16-5.86c.03.97.03,6.86.15,7.76l-.09.07c-.27,0-.53,0-.78.02l-.11-.08c.02-.74.02-1.48.02-2.21s-.04-5.6-.12-6.1l.09-.07c.39,0,.89-.01,1.32-.02l.14.07c2,2.7,2.72,3.7,5.62,7.79,0-1.05-.08-7.05-.17-7.77l.07-.06c.26-.01.57-.02.8-.02l.09.06c-.02.57-.03,1.15-.03,1.72,0,.88,0,1.77.02,2.65.02,1.33.06,2.62.12,3.95l-.09.07Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M278.67,57.91c-.03.2-.04.39-.06.6l-.09.06c-1.04-.05-2.06-.06-3.09-.06,0,.7,0,2.51.02,3.77.02,1.11.08,2.94.1,3.95l-.09.08c-.32,0-.6,0-.9.01l-.1-.07c.03-.93.03-1.86.03-2.79v-1.85c0-1.03,0-2.07-.03-3.09-.42,0-3.2.05-3.2.05l-.09-.07.06-.58.1-.06c.51.02,1.47.04,2,.04h2.84c.74,0,1.7-.02,2.42-.04l.09.06Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 83.74,
    y: 47.76,
    width: 194.59,
    height: 0.82
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M136.19,4.37c2.18,0,3.9.36,5.11,1.24,1.21.91,2,2.33,2,4.32,0,3.93-2.96,5.83-5.93,6.2-.45.06-1,.06-1.33.03l-2.21-.57v4.66c0,2.54.27,2.72,2.93,2.9v.88h-8.37v-.88c2.39-.18,2.63-.42,2.63-2.93v-12c0-2.66-.24-2.78-2.45-2.96v-.88h7.62ZM133.83,14.56c.36.18,1.18.36,2.09.36,1.81,0,4.2-1,4.2-4.9,0-3.3-2.03-4.66-4.41-4.66-.79,0-1.36.15-1.57.36-.21.18-.3.54-.3,1.33v7.5Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M153.85,24.02v-.88c1.91-.24,2.15-.51,1.72-1.72-.36-1.12-.94-2.69-1.57-4.41h-6.35c-.45,1.27-.88,2.51-1.3,3.75-.6,1.84-.36,2.15,1.9,2.39v.88h-6.62v-.88c1.94-.27,2.36-.48,3.39-3.11l6.26-15.81,1.06-.3c1.87,5.2,3.9,10.88,5.83,16.11.97,2.63,1.36,2.9,3.33,3.11v.88h-7.65ZM150.97,8.15h-.09c-.94,2.51-1.87,5.05-2.75,7.5h5.41l-2.57-7.5Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M180.12,24.26c-.33,0-.7,0-1.03-.03-2.57-.15-3.81-.85-5.14-2.78-1.03-1.45-2.06-3.3-2.93-4.78-.54-.88-1.03-1.24-2.51-1.24h-.88v4.75c0,2.57.27,2.78,2.66,2.96v.88h-8.13v-.88c2.42-.18,2.69-.39,2.69-2.96v-12.06c0-2.54-.24-2.69-2.57-2.87v-.88h7.65c2.3,0,3.78.27,4.93,1.03,1.21.79,2.03,2.15,2.03,3.96,0,2.63-1.63,4.2-3.84,5.17.51.94,1.75,2.96,2.66,4.32,1.09,1.63,1.69,2.42,2.42,3.2.79.85,1.45,1.18,2.12,1.39l-.12.82ZM168.96,14.44c1.48,0,2.48-.24,3.23-.85,1.12-.91,1.6-2.12,1.6-3.75,0-3.26-2.09-4.47-4.26-4.47-.85,0-1.36.12-1.6.3-.21.18-.3.51-.3,1.3v7.47h1.33Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M192.78,24.02v-.88c1.9-.24,2.15-.51,1.72-1.72-.36-1.12-.94-2.69-1.57-4.41h-6.35c-.45,1.27-.88,2.51-1.3,3.75-.6,1.84-.36,2.15,1.9,2.39v.88h-6.62v-.88c1.93-.27,2.36-.48,3.39-3.11l6.26-15.81,1.06-.3c1.87,5.2,3.9,10.88,5.83,16.11.97,2.63,1.36,2.9,3.33,3.11v.88h-7.65ZM189.91,8.15h-.09c-.94,2.51-1.87,5.05-2.75,7.5h5.41l-2.57-7.5Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M210.83,4.37c3.84,0,6.71.79,8.59,2.57,1.48,1.45,2.57,3.66,2.57,6.5,0,3.63-1.42,6.32-3.72,8.07-2.27,1.72-5.32,2.51-9.04,2.51h-7.26v-.88c2.54-.18,2.81-.36,2.81-2.93v-12.03c0-2.6-.24-2.72-2.57-2.9v-.91h8.62ZM207.63,20c0,2.27.91,2.87,3.08,2.87,5.38,0,8.04-4.05,8.04-8.98,0-3.08-1.12-5.71-3.36-7.1-1.33-.94-3.08-1.36-5.11-1.36-1.24,0-2,.15-2.27.36-.3.24-.39.6-.39,1.72v12.49Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M223.2,24.02v-.88c2.45-.18,2.69-.36,2.69-2.93v-12.03c0-2.57-.24-2.75-2.69-2.93v-.88h8.22v.88c-2.45.18-2.69.36-2.69,2.93v12.03c0,2.57.24,2.75,2.69,2.93v.88h-8.22Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M252.28,15.74c-1.75.27-1.9.42-1.9,2.24v2.54c0,1.06.03,2.06.21,2.87-1.87.42-4.38,1.09-6.8,1.09-6.71,0-11.16-4.11-11.16-10.13,0-6.98,5.62-10.43,11.61-10.43,2.51,0,4.84.63,5.83.88.09,1.06.24,2.72.48,4.75l-.91.21c-.72-3.66-3.02-4.75-5.89-4.75-4.44,0-7.77,3.39-7.77,8.95,0,4.41,2.51,9.43,8.16,9.43.97,0,1.88-.18,2.48-.51.58-.3.91-.73.91-1.9v-2.63c0-2.18-.18-2.36-3.18-2.6v-.88h7.92v.88Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M270.2,24.02v-.88c2.45-.24,2.54-.42,2.51-3.57l-.09-12.18h-.12l-7.26,16.42h-.63l-6.68-16.02h-.06l-.45,8.5c-.12,2.48-.12,3.84-.06,4.99.06,1.42.76,1.66,2.78,1.84v.91h-7.11v-.91c1.75-.18,2.33-.54,2.54-1.78.18-1.03.36-2.42.61-5.56l.42-6.23c.27-3.84.09-4.02-2.63-4.29v-.88h5.23l6.68,14.78,6.83-14.78h5.29v.88c-2.63.24-2.81.33-2.72,3.36l.27,10.97c.09,3.14.18,3.33,2.78,3.57v.88h-8.13Z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M132.41,35.38c1,0,1.98,0,2.98-.03l.08.08c-.03.16-.04.31-.04.48l-.13.06c-.57-.02-.78-.02-1.58-.02-.31,0-1.88.01-2.69.01,0,1.04.03,2.23.06,3.12,2.84,0,2.91-.02,4.62-.04l.06.06-.04.51-.07.06c-.55,0-.83-.01-1.65-.01h-2.5c-.38,0-.92.02-1.3.04l-.1-.09c.03-.55.03-1.11.03-1.66,0-.76,0-1.53-.01-2.29,0-.42-.1-3.2-.11-3.61l.09-.08c.44.01,1.17.02,1.84.02h1.68c.4,0,1.32-.02,1.99-.02l.09.05c-.03.15-.03.35-.04.52l-.11.06c-1.22-.03-2.47-.03-4.54-.04,0,.17.01.71.01,1.27v1.53h1.4Z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M137.44,39.61c.01-.53.03-1.05.03-1.57,0-.63-.09-5.22-.14-5.98l.1-.05c2.26-.01,2.63-.02,3.01-.02.9,0,1.87.06,2.66.35,1.1.38,2.28,1.28,2.28,3.3,0,.26,0,.88-.3,1.56-.49,1.15-1.56,1.95-3.08,2.29-.86.18-1.67.18-2.56.18h-1.24c-.23,0-.44,0-.67.01l-.08-.06ZM139.19,39.1c.76,0,1.8,0,2.54-.17,2.66-.6,2.69-2.89,2.69-3.4,0-.65-.03-2.98-3.94-2.98-.28,0-1.7.01-2.12.03v3.66c0,.81.06,2.86.06,2.86h.78Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M154.34,32.05v.6c0,.83-.01,1.87-.01,4.32,0,.86-.21,1.38-.52,1.74-.42.49-1.37,1.13-3.18,1.13-1.64,0-2.49-.57-2.9-1.02-.55-.6-.55-1.4-.55-2.1,0,0,.03-2.38.03-2.8,0-.65,0-1.18-.03-1.83l.09-.08s.68-.01.9-.02l.07.06c-.03.64-.09,2.94-.09,2.95v1.9c0,.77.09,2.33,2.6,2.33,1.33,0,2.05-.43,2.4-.98.31-.48.32-1.12.32-2.28,0-1.3,0-2.6-.07-3.89l.09-.08s.11,0,.76-.01l.09.06Z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M163.87,38.5c-.07.34-.07.47-.07.64l-.07.11c-.51.25-1.34.58-2.76.58-.69,0-2.29-.05-3.53-1.1-.9-.76-1.3-1.84-1.3-2.84,0-2.45,2.05-4.05,4.92-4.05.41,0,1.57.02,2.62.48l.07.09c-.06.17-.09.26-.11.57l-.1.05c-.75-.42-1.63-.6-2.5-.6-1.56,0-2.43.58-2.83.92-.75.65-1.09,1.65-1.09,2.5,0,1.81,1.5,3.36,3.96,3.36,1.03,0,2.08-.32,2.69-.77l.11.05Z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M171.52,39.59c-.23-.71-.49-1.38-.95-2.47h-3.92l-.17.41c-.28.67-.55,1.36-.78,2.07l-.11.06c-.1-.01-.27-.02-.41-.02s-.28.01-.42.02l-.07-.1c1.02-2.17,2.23-5.14,3.28-7.51l.09-.06c.4-.01.93-.01,1.2-.02l.1.05c.64,1.43,2.15,5.07,3.28,7.54l-.07.08c-.41.01-.96.02-.96.02l-.09-.08ZM168.58,32.39l-1.7,4.14c.58.01,1.15.01,1.71.01s1.14,0,1.71-.01l-1.72-4.14Z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M179,32.03c-.03.18-.04.36-.06.54l-.09.05c-.98-.04-1.94-.05-2.91-.05,0,.64,0,2.28.01,3.43.01,1.01.07,2.67.1,3.59l-.09.08c-.3,0-.57,0-.85.01l-.1-.06c.03-.85.03-1.69.03-2.54v-1.68c0-.93,0-1.88-.03-2.81-.4,0-3.01.04-3.01.04l-.09-.06.06-.53.1-.05c.48.02,1.39.03,1.88.03h2.67c.69,0,1.6-.02,2.28-.03l.08.05Z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M181.38,39.66c-.3,0-.59,0-.88.01l-.09-.06c.01-.53.03-1.06.03-1.6,0-.64-.03-4.98-.13-5.96l.08-.05c.3,0,.59,0,.88-.02l.09.08s-.01.7-.01,1.52v2.49c0,.68.1,2.78.11,3.53l-.08.06Z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M187.84,31.84c3.82,0,4.42,2.57,4.42,3.99,0,2.1-1.3,3.99-4.52,3.99s-4.54-1.78-4.54-3.98c0-1.82,1.06-4,4.64-4M187.81,32.42c-2.53,0-3.66,1.49-3.66,3.43,0,1.39.69,3.41,3.61,3.41s3.56-2,3.56-3.42c0-1.78-.89-3.42-3.51-3.42"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M201.57,39.65c-.47.01-1.26.02-1.26.02l-.11-.05c-.45-.56-.9-1.15-1.34-1.75l-3.92-5.33c.03.88.03,6.23.14,7.05l-.09.06c-.25,0-.49,0-.73.02l-.1-.08c.01-.67.01-1.34.01-2.01s-.04-5.09-.11-5.54l.09-.06c.37,0,.83-.01,1.24-.02l.13.06c1.88,2.45,2.56,3.36,5.29,7.07,0-.96-.07-6.4-.16-7.06l.07-.05c.24-.01.54-.02.75-.02l.09.05c-.01.52-.03,1.04-.03,1.56,0,.8,0,1.61.01,2.41.01,1.2.06,2.38.11,3.59l-.08.06Z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M213.46,32.95c-.63-.29-1.19-.53-2.26-.53-1.57,0-2.23.67-2.23,1.38,0,.79.76,1.07,1.71,1.38l1.17.38c1.13.37,2.18.93,2.18,2.09,0,1.06-1.02,2.18-3.29,2.18-.4,0-1.53-.03-2.56-.55l-.05-.12c.03-.22.04-.49.05-.65l.14-.02c.14.12.92.76,2.42.76,1.4,0,2.38-.64,2.38-1.57s-1.09-1.31-1.84-1.55l-1.14-.37c-1.16-.38-2.06-1-2.06-1.92,0-.35.2-1.99,3.17-1.99,1.2,0,1.92.25,2.37.43l.09.09-.09.53-.14.05Z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M220.01,31.84c3.82,0,4.42,2.57,4.42,3.99,0,2.1-1.3,3.99-4.52,3.99s-4.54-1.78-4.54-3.98c0-1.82,1.06-4,4.64-4M219.98,32.42c-2.53,0-3.66,1.49-3.66,3.43,0,1.39.69,3.41,3.61,3.41s3.56-2,3.56-3.42c0-1.78-.89-3.42-3.51-3.42"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M231.52,39.1c-.02.17-.04.35-.04.52l-.09.06c-.34-.01-1.7-.02-2.04-.02h-1.75c-.4,0-.79,0-1.19.02l-.09-.07c.01-.68.03-1.37.03-2.06s-.06-5.02-.13-5.48l.1-.06c.3,0,.59-.01.89-.02l.09.06c-.03.87-.04,1.73-.04,2.58,0,.54.04,4.1.06,4.46h.82c.89,0,2.21-.02,3.31-.07l.07.08Z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M239.77,32.05v.6c0,.83-.01,1.87-.01,4.32,0,.86-.21,1.38-.52,1.74-.42.49-1.37,1.13-3.18,1.13-1.64,0-2.49-.57-2.9-1.02-.55-.6-.55-1.4-.55-2.1,0,0,.03-2.38.03-2.8,0-.65,0-1.18-.03-1.83l.08-.08s.68-.01.9-.02l.07.06c-.03.64-.08,2.94-.08,2.95v1.9c0,.77.08,2.33,2.6,2.33,1.33,0,2.05-.43,2.4-.98.31-.48.33-1.12.33-2.28,0-1.3,0-2.6-.07-3.89l.08-.08s.11,0,.76-.01l.08.06Z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M248.21,32.03c-.03.18-.04.36-.06.54l-.09.05c-.98-.04-1.94-.05-2.91-.05,0,.64,0,2.28.02,3.43.01,1.01.07,2.67.1,3.59l-.09.08c-.3,0-.57,0-.85.01l-.1-.06c.03-.85.03-1.69.03-2.54v-1.68c0-.93,0-1.88-.03-2.81-.4,0-3.01.04-3.01.04l-.09-.06.06-.53.1-.05c.48.02,1.39.03,1.88.03h2.67c.69,0,1.6-.02,2.28-.03l.08.05Z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M250.58,39.66c-.3,0-.59,0-.88.01l-.09-.06c.01-.53.03-1.06.03-1.6,0-.64-.03-4.98-.13-5.96l.08-.05c.3,0,.59,0,.88-.02l.09.08s-.01.7-.01,1.52v2.49c0,.68.1,2.78.11,3.53l-.08.06Z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M257.05,31.84c3.82,0,4.43,2.57,4.43,3.99,0,2.1-1.3,3.99-4.52,3.99s-4.54-1.78-4.54-3.98c0-1.82,1.06-4,4.64-4M257.02,32.42c-2.53,0-3.66,1.49-3.66,3.43,0,1.39.69,3.41,3.61,3.41s3.56-2,3.56-3.42c0-1.78-.89-3.42-3.51-3.42"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M270.78,39.65c-.47.01-1.26.02-1.26.02l-.11-.05c-.45-.56-.9-1.15-1.34-1.75l-3.92-5.33c.03.88.03,6.23.14,7.05l-.09.06c-.25,0-.49,0-.73.02l-.1-.08c.01-.67.01-1.34.01-2.01s-.04-5.09-.11-5.54l.08-.06c.37,0,.84-.01,1.24-.02l.13.06c1.88,2.45,2.56,3.36,5.29,7.07,0-.96-.07-6.4-.15-7.06l.07-.05c.24-.01.54-.02.75-.02l.09.05c-.01.52-.03,1.04-.03,1.56,0,.8,0,1.61.01,2.41.01,1.2.05,2.38.11,3.59l-.08.06Z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M278.02,32.95c-.64-.29-1.19-.53-2.26-.53-1.57,0-2.23.67-2.23,1.38,0,.79.76,1.07,1.71,1.38l1.17.38c1.13.37,2.18.93,2.18,2.09,0,1.06-1.02,2.18-3.3,2.18-.4,0-1.53-.03-2.56-.55l-.06-.12c.03-.22.04-.49.06-.65l.14-.02c.14.12.92.76,2.42.76,1.4,0,2.38-.64,2.38-1.57s-1.09-1.31-1.84-1.55l-1.15-.37c-1.16-.38-2.06-1-2.06-1.92,0-.35.2-1.99,3.17-1.99,1.2,0,1.92.25,2.37.43l.08.09-.08.53-.14.05Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-14"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 108.91,
    y: 0.15,
    width: 16.95,
    height: 16.95,
    transform: "translate(83.95 121.48) rotate(-77.7)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 98.01,
    y: 27.82,
    width: 11.98,
    height: 11.98
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 83.73,
    y: 27.83,
    width: 11.98,
    height: 11.98
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 109.99,
    y: 15.86,
    width: 11.98,
    height: 11.98
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 95.77,
    y: 15.86,
    width: 11.99,
    height: 11.98
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 109.98,
    y: 27.83,
    width: 11.98,
    height: 11.99
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParadigmLogoSignInPage);
export default __webpack_public_path__ + "static/media/Paradigm-Logo_Sign-In-Page.f5aca9e9506956d13e48a2722c3b3a52.svg";
export { ForwardRef as ReactComponent };